import PropertyInformationTags from "./PropertyInformationTags"

export default PropertyInformationTags
